module.exports = __webpack_public_path__ + "img/ic-youtube.715a0ca2.svg";